import React from "react";
import { v4 } from "uuid";
import { getIcon } from "../../Components/Functions";
import Api from "../../Server/Api";

const api = new Api();

export const VerificationDocument = (props) => {
	const [documents, setDocuments] = React.useState([
		{
			name: "Annual License",
			file: null,
			input: React.useRef(null)
		},
		{
			name: "Identification Card",
			file: null,
			input: React.useRef(null)
		},
		{
			name: "Passport photo (optional)",
			file: null,
			input: React.useRef(null)
		},
		{
			name: "Bank Details",
			file: null,
			input: React.useRef(null)
		}		
	]);

	React.useEffect(() => {
		if(props?.documents?.length > 0){
			const docs = props?.documents || [];
			setDocuments(documents.map((e) => {
				const doc = docs.find((_) => _.name === e.name)
				return doc ? { ...e, file: doc.file } : e
			}))
		}
	}, [props?.documents])

	const remove = (id) => {
		const docs = documents.map((e) => {
			if(e.id === id){
				return { ...e, uploading: true }
			}
			return e;
		})
		setDocuments(docs);
		api.del({ endpoint: "file-upload/"+id+"/" }).then((res) => {
			setDocuments(documents.filter(e => e.id !== id))
		})

	}

	const onFileChange = (e, name) => {
		let files = e.target.files || e.dataTransfer.files;
		if (!files.length) return;
		createImage(files[0], name);
	};

	const createImage = (file, name) => {
		const doc = { id: v4(), name, file, uploading: true };
		let new_docs = documents.map((e) => { return e.name === name ? { ...e, uploading: true } : e })
		setDocuments(new_docs);
		uploadFile(new_docs, doc);
		props.callback && props.callback([...props.value, doc]);
	};

	const uploadFile = (documents = [], doc) => {
		var formData = new FormData();
		formData.append("name", doc.name);
		formData.append("if_existing", "replace");
		formData.append("file", doc.file);
		formData.append("user", props?.userId);
		api.post({
			endpoint: "file-upload/",
			data: formData,
			headers: { "Content-Type": "multipart/form-data" }
		}).then((res) => {
			if(res?.id > 0){
				const docs = documents.map((e) => { return e.name === doc.name ? { ...e, ...res, uploading: false } : e })
				setDocuments(docs)
			}
		}).catch((err) => {
			const docs = documents.map((e) => { return e.name === doc.name ? { ...e, uploading: false } : e })
			setDocuments(docs)
		})
	}

	return (
		<div className="stepper-form p-0 m-0 w-100">
			<div className="form-sections  px-3 w-100">
				<div id="form-step-1" className="form-section w-100 is-active">
					

					<div className="form-section-output">
						{documents &&
							documents.map((doc, i) => {
								return (
									<div className={`output `} key={v4()}>
										<i style={{ fontSize: 20 }} className={`mdi ${doc.file ? "mdi-check-circle text-success" : "mdi-close-circle text-danger"} mr-3`} />

										<span onClick={() => { (doc?.url || doc.file) && window.open((doc?.url || doc.file), "_target") }}>{doc?.name || "-No Name-"}</span>
										
										<input
											ref={doc.input}
											type="file"
											style={{ display: "none" }}
											onChange={(e) => onFileChange(e, doc.name)}
										/>

										{!props?.readOnly && (
											<div className="action">
												<button 
													className={`${doc.uploading ? "button is-loading":""} `}
                                                    onClick={() => doc.input.current.click()}
													dangerouslySetInnerHTML={{ __html: getIcon("upload") }}
                                                />
											</div>
										)}
									</div>
								);
							})}
					</div>
				</div>
			</div>
		</div>
	);
};

